import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import {
  Monitor, Award, Calculator, Globe, FileText, Users,
  BookOpen, Star, Briefcase, Lightbulb, HeartHandshake, Laptop
} from "lucide-react";

const ICON_MAP = {
  Monitor, Award, Calculator, Globe, FileText, Users,
  BookOpen, Star, Briefcase, Lightbulb, HeartHandshake, Laptop,
};

const ACCENT_COLORS = [
  "bg-[#1B4332]",
  "bg-[#E07A5F]",
  "bg-[#2D6A4F]",
  "bg-[#D4A574]",
  "bg-[#5C6661]",
  "bg-[#8B7355]",
];

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  if (services.length === 0) return null;

  return (
    <section id="services" className="py-24 bg-[#F2EFEB]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="overline text-[#E07A5F]">What We Offer</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3 leading-tight">
            Our Services
          </h2>
          <p className="mt-4 text-[#5C6661] leading-relaxed">
            From professional computer training to career counselling — we provide
            everything you need to build a successful future.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="services-list">
          {services.map((s, idx) => {
            const Icon = ICON_MAP[s.icon] || Star;
            const accent = ACCENT_COLORS[idx % ACCENT_COLORS.length];
            return (
              <div
                key={s.id}
                className="group bg-white border border-border rounded-2xl p-7 hover:border-[#1B4332] hover:shadow-md transition-all"
                data-testid={`service-card-${s.id}`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${accent}`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-serif-display text-xl text-[#1B4332] leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-[#5C6661] leading-relaxed">{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
